import styled, { css } from 'styled-components/macro';
import { colorsMap } from './badge.colors';
import { StyledBadgeProps } from './badge.types';

export const BadgeContainer = styled.div<StyledBadgeProps>`
  ${({ theme, $size, $mode, $variant, $shape }) => {
    return css`
      box-sizing: border-box;
      padding-inline: ${theme.spacings.s};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: ${theme.spacings.xs};
      width: fit-content;
      max-width: 100%;
      height: ${$size === 's' ? 24 : 32}px;
      border-radius: ${$shape === 'round'
        ? theme.radiuses.full
        : theme.radiuses.xxs};
      transition-duration: ${theme.tokens.animation.duration.base};

      &[data-disabled='true'] {
        background-color: ${theme.semantic.indication.bgDisabled};
        color: ${theme.semantic.indication.textDisabled};
        cursor: not-allowed;
      }

      ${colorsMap(theme)[$mode][$variant]};

      span {
        display: block;
        ${theme.fonts['body-14'].css};
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    `;
  }}
`;
